import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../Components/Styles/LoginSingup.css';

function Register() {
  const navigate = useNavigate();
  
  const [email, setEmail] = useState('');
  const [pseudo, setPseudo] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConf, setPasswordConf] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    if (password !== passwordConf) {
      setMessage('Les mots de passe ne correspondent pas.');
      return;
    }

    const formData = new FormData();
    formData.append('email', email);
    formData.append('pseudo', pseudo);
    formData.append('mdp', password);
    formData.append('mdpconf', passwordConf);

    fetch('/api/reg.php', { /*A CHANGER*/
      method: 'POST',
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          setMessage('Inscription réussie. Un email de confirmation a été envoyé.');
          setTimeout(() => navigate('/login'), 2000);
        } else {
          setMessage(data.message || 'Erreur inconnue');
        }
      })
      .catch((error) => {
        console.error('Erreur:', error);
        setMessage('Erreur de connexion au serveur');
      });
  };

  return (
    <div className="formulaire-container">
      <div className="formulaire" id='formulaire' onSubmit={handleSubmit}>
          <form className='form-login'>
            <h2 className='login-title'>S'inscrire</h2>
            <input className='input-design' name="Pseudo" type="text" value={pseudo} onChange={(e) => setPseudo(e.target.value)} placeholder="Pseudo" required pattern="^[A-Za-zÀ-ÿ'-]+$" max="20"/>

            <input className='input-design' name="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" required pattern="^[A-Za-z0-9'_.-]+@{1}[A-Za-z0-9]+.[A-Za-z]{2,}$"/>

            <input className='input-design' name="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Mot de passe" required pattern="^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[@!?$/\=*.-]).{6,18}$"/>

            <input className='input-design' name="Confirm password" type="password" value={passwordConf} onChange={(e) => setPasswordConf(e.target.value)} placeholder="Confirmer le mot de passe" required pattern="^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[@!?$/\=*.-]).{6,18}$"/>

            <button className='valider' type='submit'>S'inscrire</button>
            {message && <p>{message}</p>}
          </form>
          <div className="form-info overlay-right">
              <div className="form-title">Te revoilà ?</div>
              <div className="form-desc">Connecte toi pour commander et accéder à ton espace personnel.</div>
              <Link className='link-login' to='../login'>
                  <button type="button" id='singIn'>Se connecter</button>
              </Link>
          </div>
      </div>
    </div>
  );
}

export default Register;